export const ScreenSize = {
    Mobile: 1,
    Tablet: 2,
    Desktop: 3
}